import type { FC } from "react";
import { useState } from "react";
import ChevronDownIcon from "@untitled-ui/icons-react/build/esm/ChevronDown";
import ChevronRightIcon from "@untitled-ui/icons-react/build/esm/ChevronRight";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import SvgIcon from "@mui/material/SvgIcon";
import Typography from "@mui/material/Typography";
import { useTranslation } from "react-i18next";
import { markdownComponents } from "src/pages/dashboard/helpers/markdownlhelpers";
import { PluggableList } from "react-markdown/lib";
import rehypeRaw from "rehype-raw";
import remarkGfm from "remark-gfm";
import Markdown from "react-markdown";

interface FaqType {
  question: string;
  answer: string;
}

interface FaqProps {
  answer: string;
  question: string;
}

const Faq: FC<FaqProps> = (props) => {
  const { answer, question } = props;
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  return (
    <Stack
      onClick={() => setIsExpanded((prevState) => !prevState)}
      spacing={2}
      sx={{ cursor: "pointer" }}
    >
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        spacing={2}
      >
        <Typography variant="subtitle1">{question}</Typography>
        <SvgIcon>
          {isExpanded ? <ChevronDownIcon /> : <ChevronRightIcon />}
        </SvgIcon>
      </Stack>
      <Collapse in={isExpanded}>
        <Typography color="text.secondary" variant="body2">
          {/* <div dangerouslySetInnerHTML={{ __html: answer }} /> */}
          <Markdown
            children={answer}
            components={markdownComponents}
            remarkPlugins={[remarkGfm]}
            rehypePlugins={[rehypeRaw] as PluggableList}
          />
        </Typography>
      </Collapse>
    </Stack>
  );
};

export const HomeFaqs: FC = () => {
  const { t } = useTranslation();
  const faqs: FaqType[] = [
    // {
    //   question: t("Is open-source looping safe?"),
    //   answer: t("IsItSafeDescription"),
    // },
    {
      question: t("What equipment do I need to start looping?"),
      answer: t("EquipmentDescription"),
    },
    {
      question: t("What is Nightscout?"),
      answer: t("NightscoutDescription"),
    },
    {
      question: t("WhyOpenSourceLooping"),
      answer: t("WhyOpenSourceLoopingAnswer"),
    },
    {
      question: t(
        "What is the difference between open-source looping and commercial systems?"
      ),
      answer: t("OpenSourceVsCommercialDescription"),
    },
    {
      question: t("How can you support me?"),
      answer: t("SupportTopicsDescription"),
    },
    {
      question: t(
        "How quickly will I receive a response if I contact the support team?"
      ),
      answer: t("SupportResponseTimeDescription"),
    },
    {
      question: t("Is open-source looping legal?"),
      answer: t("LegalDescription"),
    },
    {
      question: t("MedicalCommunityOpinion"),
      answer: t("MedicalCommunityOpinionAnswer"),
    },
    {
      question: t("IsServiceLegal"),
      answer: t("IsServiceLegalAnswer"),
    },
    {
      question: t("WhatAboutFb"),
      answer: t("FbGroups"),
    },
    {
      question: t("In which languages do you provide support?"),
      answer: t("SupportLanguagesDescription"),
    },
  ];

  return (
    <Box sx={{ py: "120px", bgcolor: "grey.50" }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid xs={12} md={6}>
            <Stack spacing={2}>
              <Typography
                component="h2"
                variant="h3"
                sx={{ color: "primary.main" }}
              >
                {t("Frequently asked questions")}
              </Typography>
              {/* <Typography color="text.secondary" variant="subtitle2">
                Frequently asked questions
              </Typography> */}
            </Stack>
          </Grid>
          <Grid xs={12} md={6}>
            <Stack spacing={4}>
              {faqs.map((faq, index) => (
                <Faq key={index} {...faq} />
              ))}
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
